export default function createVaultUrl({ vaultUrl = '', tntId, environment, satellitePort }) {
  const port = parseInt(satellitePort, 10);
  if (environment === 'sandbox' && !isNaN(port)) {
    return `http://localhost:${port}`;
  }

  if (vaultUrl) {
    return vaultUrl.trim();
  }

  return `https://${tntId}.${environment}.verygoodproxy.${VGS_ENV}`;
}
